import * as React from "react";

const ViewFilters: React.FC<{
  onClick: (evt: any) => void;
}> = ({ onClick }) => {
  return (
    <button
      className="button button__gradient button__override"
      type="button"
      name="view"
      onClick={onClick}
    >
      View Filters
    </button>
  );
};

export default ViewFilters;
